import { getNumericValue, getRootFontSize, isWhite } from "../../utils/stringUtils.js";
import { alpha } from "@mui/material";
import { DEFAULT_THEME_OPTIONS, getDefaultThemePalette } from "../defaultTheme.js";
import { toNumber } from "lodash";
import { filterShallowUndefinedObjectEntries } from "../../utils/objectUtils.js";
import { DTCComponentName, ButtonName } from "../componentNames.js";
const CHECKOUT_COMPONENT_LEGACY_THEME_KEYS = [
  { legacyKey: "membershipButton", contentKey: "membershipButton", variantKey: "signedOutDesktop" },
  { legacyKey: "membershipButton", contentKey: "membershipButton", variantKey: "signedInDesktop" },
  { legacyKey: "membershipButtonMobile", contentKey: "membershipButton", variantKey: "signedOutMobile" },
  { legacyKey: "membershipButtonMobile", contentKey: "membershipButton", variantKey: "signedInMobile" },
  { legacyKey: "bagButton", contentKey: "cartButton", variantKey: "signedOutDesktop" },
  { legacyKey: "bagButton", contentKey: "cartButton", variantKey: "signedInDesktop" },
  { legacyKey: "bagButtonMobile", contentKey: "cartButton", variantKey: "signedOutMobile" },
  { legacyKey: "bagButtonMobile", contentKey: "cartButton", variantKey: "signedInMobile" },
  { legacyKey: "profileButton", contentKey: "profileButton", variantKey: "signedOutDesktop" },
  { legacyKey: "profileButton", contentKey: "profileButton", variantKey: "signedInDesktop" },
  { legacyKey: "profileButtonMobile", contentKey: "profileButton", variantKey: "signedOutMobile" },
  { legacyKey: "profileButtonMobile", contentKey: "profileButton", variantKey: "signedInMobile" },
  { legacyKey: "buyButton", contentKey: "addToBagButton", variantKey: "signedOutDesktop" },
  { legacyKey: "buyButton", contentKey: "addToBagButton", variantKey: "signedInDesktop" },
  { legacyKey: "buyButtonMobile", contentKey: "addToBagButton", variantKey: "signedOutMobile" },
  { legacyKey: "buyButtonMobile", contentKey: "addToBagButton", variantKey: "signedInMobile" },
  { legacyKey: "plpAddToBagButton", contentKey: "plpAddToBagButton", variantKey: "signedOutDesktop" }
];
const getObjectIfHasValues = (obj) => {
  if (!obj) {
    return void 0;
  }
  return Object.values(obj).every((value) => [void 0, null, ""].includes(value)) ? void 0 : obj;
};
const findLegacyThemeValue = (legacyThemeValue, key, condition) => {
  var _a;
  if (!legacyThemeValue) {
    return void 0;
  }
  const valueMap = /* @__PURE__ */ new Map();
  Object.values(legacyThemeValue).forEach((component) => {
    if (typeof component !== "object" || !component) {
      return;
    }
    const value = component[key];
    if (value) {
      valueMap.set(value, (valueMap.get(value) || 0) + 1);
    }
  });
  const sortedValues = Array.from(valueMap.entries()).sort((a, b) => b[1] - a[1]);
  return (_a = sortedValues.find(([value]) => true)) == null ? void 0 : _a[0];
};
const normalizeFontWeight = (value) => {
  if (typeof value === "string") {
    const numericValue = toNumber(value);
    if (Number.isFinite(numericValue)) {
      return numericValue;
    }
    return value.toLowerCase();
  }
  return value;
};
const getThemeColors = (legacyTheme) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const legacyContrastText = (_b = (_a = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _a.buyButton) == null ? void 0 : _b.fontColor;
  const defaultPalette = getDefaultThemePalette();
  let accent = void 0;
  const background = {};
  let primary = {
    contrastText: legacyContrastText,
    main: defaultPalette.primary.main
  };
  const secondary = {
    contrastText: legacyContrastText,
    main: defaultPalette.secondary.main
  };
  const tertiary = {
    contrastText: legacyTheme.primary ?? legacyContrastText,
    main: defaultPalette.tertiary.main
  };
  let textColor = void 0;
  const legacyAnimationDotColor = findLegacyThemeValue(legacyTheme.inpageCheckoutComponent, "animationDotColor");
  if (legacyAnimationDotColor) {
    accent = { main: legacyAnimationDotColor, contrastText: legacyContrastText };
  }
  if ((_d = (_c = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _c.buyButton) == null ? void 0 : _d.backgroundColor) {
    primary = {
      main: legacyTheme.inpageCheckoutComponent.buyButton.backgroundColor,
      contrastText: legacyTheme.inpageCheckoutComponent.buyButton.fontColor
    };
  }
  if (legacyTheme.componentStyleOverrides) {
    const legacySecondaryColor = findLegacyThemeValue(legacyTheme.componentStyleOverrides, "secondary");
    if (legacySecondaryColor) {
      secondary.main = legacySecondaryColor;
    }
  }
  if (legacyTheme.secondary) {
    secondary.main = legacyTheme.secondary;
  }
  if (legacyTheme.primary) {
    textColor = legacyTheme.primary;
  }
  if (legacyTheme.tertiary && ![primary == null ? void 0 : primary.main, secondary == null ? void 0 : secondary.main, "", "#"].includes((_e = legacyTheme.tertiary) == null ? void 0 : _e.trim()) && !isWhite(legacyTheme.tertiary)) {
    tertiary.main = legacyTheme.tertiary;
  }
  if ((_f = legacyTheme.dtcGetApp) == null ? void 0 : _f.backgroundColor) {
    background.alternate = legacyTheme.dtcGetApp.backgroundColor;
  }
  if ((_i = (_h = (_g = legacyTheme.componentStyleOverrides) == null ? void 0 : _g.dialog) == null ? void 0 : _h.backgroundColor) == null ? void 0 : _i.trim()) {
    background.paper = legacyTheme.componentStyleOverrides.dialog.backgroundColor;
    background.default = background.paper;
  }
  return {
    accent: getObjectIfHasValues(accent) ?? defaultPalette.accent,
    background: getObjectIfHasValues(background) ?? defaultPalette.background,
    primary: getObjectIfHasValues(primary) ?? defaultPalette.primary,
    secondary: getObjectIfHasValues(secondary) ?? defaultPalette.secondary,
    tertiary: getObjectIfHasValues(tertiary) ?? defaultPalette.tertiary,
    default: {
      main: textColor ?? defaultPalette.default.main
    },
    textColor
  };
};
const getThemeSmartBannerType = (legacyTheme) => {
  var _a, _b, _c;
  const androidSmartBannerEnabled = !!((_a = legacyTheme.smartAppBanner) == null ? void 0 : _a.androidPopup);
  const iosSmartBannerEnabled = !!((_b = legacyTheme.smartAppBanner) == null ? void 0 : _b.iosSmartBanner) || !!((_c = legacyTheme.getAppBanner) == null ? void 0 : _c.iosSmartBanner);
  if (androidSmartBannerEnabled && iosSmartBannerEnabled) {
    return "both";
  }
  if (androidSmartBannerEnabled) {
    return "android";
  }
  if (iosSmartBannerEnabled) {
    return "ios";
  }
  return "none";
};
const getThemeAppSettings = (legacyTheme) => {
  var _a, _b, _c, _d, _e;
  const themeAppSettings = {
    smartBannerType: getThemeSmartBannerType(legacyTheme)
  };
  if (legacyTheme.dtcGetApp) {
    themeAppSettings.dtcGetAppImage = ((_a = legacyTheme.dtcGetApp) == null ? void 0 : _a.appImage) || void 0;
  }
  if (legacyTheme.getAppBanner) {
    themeAppSettings.iosCustomBannerAlignment = {
      align: (_b = legacyTheme.getAppBanner.iosCustomBanner) == null ? void 0 : _b.align,
      alignOffset: (_c = legacyTheme.getAppBanner.iosCustomBanner) == null ? void 0 : _c.alignOffset
    };
    themeAppSettings.androidCustomBannerAlignment = {
      align: (_d = legacyTheme.getAppBanner.androidCustomBanner) == null ? void 0 : _d.align,
      alignOffset: (_e = legacyTheme.getAppBanner.androidCustomBanner) == null ? void 0 : _e.alignOffset
    };
  }
  return themeAppSettings;
};
const getThemeFeatureFlags = (legacyTheme) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  return {
    bagAnimationDot: (_b = (_a = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _a.bagButton) == null ? void 0 : _b.animationDot,
    scrollSliderDisplay: (_d = (_c = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _c.buyButton) == null ? void 0 : _d.enableScrollSliderDisplay,
    storeLocatorMap: (_f = (_e = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _e.buyButton) == null ? void 0 : _f.enableLocationMap,
    cartCountNumber: (_h = (_g = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _g.bagButton) == null ? void 0 : _h.countNumber,
    bagAnimationDotMobile: (_j = (_i = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _i.bagButtonMobile) == null ? void 0 : _j.animationDot,
    scrollSliderDisplayMobile: (_l = (_k = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _k.buyButtonMobile) == null ? void 0 : _l.enableScrollSliderDisplay,
    storeLocatorMapMobile: (_n = (_m = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _m.buyButtonMobile) == null ? void 0 : _n.enableLocationMap,
    cartCountNumberMobile: (_p = (_o = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _o.bagButtonMobile) == null ? void 0 : _p.countNumber,
    scrollSliderDisplayDistance: getNumericValue(
      (_r = (_q = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _q.buyButton) == null ? void 0 : _r.scrollSliderDisplayDistance
    ),
    scrollSliderDisplayDistanceMobile: getNumericValue(
      (_t = (_s = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _s.buyButtonMobile) == null ? void 0 : _t.scrollSliderDisplayDistance
    ),
    showBuyBoxOnNonEligibleClick: (_v = (_u = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _u.plpAddToBagButton) == null ? void 0 : _v.showBuyBoxOnNonEligibleClick
  };
};
const getThemePillPresets = (legacyTheme) => {
  const globalComponentPillPresets = {};
  const legacyPillStyles = legacyTheme.customRewardPillColor;
  if (legacyPillStyles) {
    globalComponentPillPresets.default = getObjectIfHasValues({
      main: legacyPillStyles.default,
      contrastText: legacyPillStyles.defaultText
    });
    globalComponentPillPresets.outOfStock = getObjectIfHasValues({
      main: legacyPillStyles.outOfStock,
      contrastText: legacyPillStyles.outOfStockText
    });
    globalComponentPillPresets.purchase = getObjectIfHasValues({
      main: legacyPillStyles.purchase,
      contrastText: legacyPillStyles.purchaseText
    });
    globalComponentPillPresets.survey = getObjectIfHasValues({
      main: legacyPillStyles.survey,
      contrastText: legacyPillStyles.surveyText
    });
    globalComponentPillPresets.content = getObjectIfHasValues({
      main: legacyPillStyles.content,
      contrastText: legacyPillStyles.contentText
    });
    globalComponentPillPresets.affiliate = getObjectIfHasValues({
      main: legacyPillStyles.affiliate,
      contrastText: legacyPillStyles.affiliateText
    });
    globalComponentPillPresets.dailyDeal = getObjectIfHasValues({
      main: legacyPillStyles.dailyDeal,
      contrastText: legacyPillStyles.dailyDealText
    });
  }
  return getObjectIfHasValues(globalComponentPillPresets);
};
const getThemeCheckoutDrawerPresets = (legacyTheme) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const result = {
    customHeaderName: (_a = legacyTheme == null ? void 0 : legacyTheme.checkoutDrawer) == null ? void 0 : _a.customHeaderName,
    customEmptyBagMessageCardHeaderText: (_c = (_b = legacyTheme == null ? void 0 : legacyTheme.componentStyleOverrides) == null ? void 0 : _b.emptyBagMessageCard) == null ? void 0 : _c.customHeaderText,
    customCheckoutText: (_d = legacyTheme == null ? void 0 : legacyTheme.checkoutDrawer) == null ? void 0 : _d.customCheckoutText,
    customViewBagText: (_e = legacyTheme == null ? void 0 : legacyTheme.checkoutDrawer) == null ? void 0 : _e.customViewBagText,
    checkoutDrawerHeaderButton: (_g = (_f = legacyTheme == null ? void 0 : legacyTheme.globalComponentPresets) == null ? void 0 : _f.checkoutDrawer) == null ? void 0 : _g.checkoutDrawerHeaderButton
  };
  const hasValue = Object.values(result).some((v) => v !== void 0 && v !== null && `${v}`.trim() !== "");
  return hasValue ? result : void 0;
};
const getThemeComponentPresets = (legacyTheme) => {
  var _a, _b, _c, _d, _e, _f;
  const iconSize = findLegacyThemeValue(
    {
      membershipButton: (_a = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _a.membershipButton,
      bagButton: (_b = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _b.bagButton,
      profileButton: (_c = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _c.profileButton,
      buyButton: (_d = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _d.buyButton
    },
    "size"
  );
  const borderWidth = getNumericValue((_f = (_e = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _e.buyButton) == null ? void 0 : _f.borderWidth);
  const componentOptions = {
    BCSolidButton: {
      styleOverrides: {
        root: {
          borderRadius: legacyTheme.globalButtonRadius
        }
      }
    },
    BCOutlineButton: {
      styleOverrides: {
        root: {
          borderRadius: legacyTheme.globalButtonRadius,
          // ensure a borderWidth of 0 gets omitted. This is because 0 was the default empty value for borderWidth in legacy theme
          ...borderWidth && { borderWidth }
        }
      }
    },
    BCTextButton: {
      styleOverrides: {
        root: {
          borderRadius: legacyTheme.globalButtonRadius
        }
      }
    },
    BCIconButton: {
      defaultProps: {
        height: getNumericValue(iconSize)
      },
      styleOverrides: {
        root: {
          borderRadius: legacyTheme.globalButtonRadius
        }
      }
    }
  };
  return componentOptions;
};
const getThemeContentPresets = (legacyTheme, isShopDomain) => {
  var _a;
  const themeContent = {};
  const savedContent = legacyTheme.content;
  if (savedContent == null ? void 0 : savedContent.buyBoxDialog) {
    themeContent.buyBoxDialog = savedContent.buyBoxDialog;
  }
  if ((_a = legacyTheme.customConnectReward) == null ? void 0 : _a.headerText) {
    themeContent.connectRewardHeader = {
      signedOutDesktop: legacyTheme.customConnectReward.headerText,
      signedInDesktop: legacyTheme.customConnectReward.headerText,
      signedOutMobile: legacyTheme.customConnectReward.headerText,
      signedInMobile: legacyTheme.customConnectReward.headerText
    };
  }
  if (legacyTheme.inpageCheckoutComponent) {
    CHECKOUT_COMPONENT_LEGACY_THEME_KEYS.forEach(({ legacyKey, contentKey, variantKey }) => {
      var _a2;
      const legacyComponent = (_a2 = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _a2[legacyKey];
      if (legacyComponent) {
        const isTextButton = "textButton" in legacyComponent ? legacyComponent.textButton : !!legacyComponent.text;
        const dtcImgUrl = "dtcImageUrl" in legacyComponent ? legacyComponent.dtcImageUrl : void 0;
        const imgUrl = "imageUrl" in legacyComponent ? legacyComponent.imageUrl : void 0;
        const customIconStartSrc = isShopDomain && dtcImgUrl || imgUrl;
        themeContent[contentKey] = {
          ...themeContent[contentKey],
          [variantKey]: {
            text: isTextButton ? legacyComponent.text : void 0,
            customIconStartSrc: !isTextButton ? customIconStartSrc : void 0,
            ...contentKey === "plpAddToBagButton" && {
              text: legacyComponent == null ? void 0 : legacyComponent.buttonTextOverwrite,
              hideBottomLine: legacyComponent == null ? void 0 : legacyComponent.hideBottomLine
            }
          }
        };
      }
    });
  }
  return themeContent;
};
const resolveLegacyFont = (legacyTheme, key) => {
  var _a, _b, _c, _d;
  return legacyTheme.activeInpageCheckout ? ((_a = legacyTheme.dtcFonts) == null ? void 0 : _a[key]) ?? ((_b = legacyTheme.barFonts) == null ? void 0 : _b[key]) : ((_c = legacyTheme.barFonts) == null ? void 0 : _c[key]) ?? ((_d = legacyTheme.dtcFonts) == null ? void 0 : _d[key]);
};
const getThemeTypography = (legacyTheme) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const themeFontSettings = {};
  themeFontSettings.numericFontOffsetY = toNumber(
    findLegacyThemeValue(legacyTheme.inpageCheckoutComponent, "countNumberYOffset")
  );
  if (isNaN(themeFontSettings.numericFontOffsetY)) {
    themeFontSettings.numericFontOffsetY = void 0;
  }
  const fontWeight = normalizeFontWeight(
    ((_a = legacyTheme.font) == null ? void 0 : _a.fontWeight) ?? ((_b = legacyTheme.dtcFonts) == null ? void 0 : _b.fontWeight) ?? ((_c = legacyTheme.barFonts) == null ? void 0 : _c.fontWeight)
  );
  const fontFamilyLink = resolveLegacyFont(legacyTheme, "fontFamilyLink");
  const assignedFonts = resolveLegacyFont(legacyTheme, "assignedFonts");
  const viewBagTextOffsetY = resolveLegacyFont(legacyTheme, "viewBagTextOffsetY");
  themeFontSettings.fontFamilyLink = fontFamilyLink;
  themeFontSettings.assignedFonts = assignedFonts;
  themeFontSettings.fontWeight = fontWeight;
  themeFontSettings.fontOffsetY = viewBagTextOffsetY;
  const baseFontSize = resolveLegacyFont(legacyTheme, "baseFontSize");
  const fontFamily = resolveLegacyFont(legacyTheme, "fontFamily");
  const btnFontWeight = normalizeFontWeight((_e = (_d = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _d.buyButton) == null ? void 0 : _e.fontWeight);
  const lgButtonFontSize = getNumericValue((_g = (_f = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _f.buyButton) == null ? void 0 : _g.fontSize);
  const DEFAULT_BROWSER_FONT_SIZE = 16;
  const htmlFontSize = getRootFontSize() ?? DEFAULT_BROWSER_FONT_SIZE;
  const typography = {
    fontFamily,
    fontSize: baseFontSize,
    htmlFontSize,
    xsButton: {
      ...DEFAULT_THEME_OPTIONS.typography.xsButton,
      fontWeight: btnFontWeight,
      fontFamily: fontFamily ?? "inherit"
    },
    smButton: {
      ...DEFAULT_THEME_OPTIONS.typography.smButton,
      fontWeight: btnFontWeight,
      fontFamily: fontFamily ?? "inherit"
    },
    button: {
      ...DEFAULT_THEME_OPTIONS.typography.button,
      fontWeight: btnFontWeight,
      fontFamily: fontFamily ?? "inherit"
    },
    lgButton: {
      ...DEFAULT_THEME_OPTIONS.typography.lgButton,
      ...!!lgButtonFontSize && { fontSize: `${lgButtonFontSize}px` },
      fontWeight: btnFontWeight,
      fontFamily: fontFamily ?? "inherit"
    }
  };
  return { fontSettings: themeFontSettings, typography };
};
const getThemeComponentCSSOverrides = (legacyTheme) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
  const buyButtonMobileTheme = (_a = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _a.buyButtonMobile;
  const buyButtonTheme = (_b = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _b.buyButton;
  const bagButton = (_c = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _c.bagButton;
  const bagButtonMobile = (_d = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _d.bagButtonMobile;
  const checkoutBarBagButton = (_e = legacyTheme.componentStyleOverrides) == null ? void 0 : _e.cartButton;
  const membershipButton = (_f = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _f.membershipButton;
  const membershipButtonMobile = (_g = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _g.membershipButtonMobile;
  const profileButton = (_h = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _h.profileButton;
  const profileButtonMobile = (_i = legacyTheme.inpageCheckoutComponent) == null ? void 0 : _i.profileButtonMobile;
  const locationMapSearchResultsButton = (_j = legacyTheme.componentStyleOverrides) == null ? void 0 : _j.locationMapSearchResultsButton;
  const checkoutQuantityControl = (_k = legacyTheme.componentStyleOverrides) == null ? void 0 : _k.checkoutQuantityControl;
  const emptyBagMessageCard = (_l = legacyTheme.componentStyleOverrides) == null ? void 0 : _l.emptyBagMessageCard;
  const emptyBagMessageCardButton = (_m = legacyTheme.componentStyleOverrides) == null ? void 0 : _m.emptyBagMessageCardButton;
  const outlineStyle = legacyTheme.activeInpageCheckout === false && !!checkoutBarBagButton ? {
    outlineColor: checkoutBarBagButton.tertiary
  } : void 0;
  const isEmptyObject = (obj) => {
    return Object.values(obj).every((value) => value === void 0 || value === null || value === "");
  };
  const addIfNotEmpty = (target, key, breakpoints) => {
    const validBreakpoints = {};
    if (breakpoints.xs && !isEmptyObject(breakpoints.xs)) {
      validBreakpoints.xs = breakpoints.xs;
    }
    if (breakpoints.md && !isEmptyObject(breakpoints.md)) {
      validBreakpoints.md = breakpoints.md;
    }
    if (Object.keys(validBreakpoints).length > 0) {
      target[key] = validBreakpoints;
    }
  };
  const componentCSSOverrides = {};
  addIfNotEmpty(componentCSSOverrides, DTCComponentName.EmptyBagMessageCard, {
    xs: {
      backgroundColor: (emptyBagMessageCard == null ? void 0 : emptyBagMessageCard.backgroundColor) || void 0,
      color: (emptyBagMessageCard == null ? void 0 : emptyBagMessageCard.textColor) || void 0
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.AddToBagButton, {
    xs: {
      color: (buyButtonMobileTheme == null ? void 0 : buyButtonMobileTheme.fontColor) ?? void 0,
      height: (buyButtonMobileTheme == null ? void 0 : buyButtonMobileTheme.buttonHeight) ?? void 0,
      width: (buyButtonMobileTheme == null ? void 0 : buyButtonMobileTheme.fullWidth) ? "100%" : void 0,
      borderRadius: (buyButtonMobileTheme == null ? void 0 : buyButtonMobileTheme.borderRadius) ?? void 0,
      fontSize: (buyButtonMobileTheme == null ? void 0 : buyButtonMobileTheme.fontSize) ? getNumericValue(buyButtonMobileTheme == null ? void 0 : buyButtonMobileTheme.fontSize) : void 0
    },
    md: {
      color: (buyButtonTheme == null ? void 0 : buyButtonTheme.fontColor) ?? void 0,
      height: (buyButtonTheme == null ? void 0 : buyButtonTheme.buttonHeight) ?? void 0,
      width: (buyButtonTheme == null ? void 0 : buyButtonTheme.fullWidth) ? "100%" : void 0,
      borderRadius: (buyButtonTheme == null ? void 0 : buyButtonTheme.borderRadius) ?? void 0,
      fontSize: (buyButtonTheme == null ? void 0 : buyButtonTheme.fontSize) ? getNumericValue(buyButtonTheme == null ? void 0 : buyButtonTheme.fontSize) : void 0
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.BagDrawerCheckoutButton, {
    xs: {
      borderRadius: ((_o = (_n = legacyTheme.componentStyleOverrides) == null ? void 0 : _n.bagDrawerCheckoutButton) == null ? void 0 : _o.globalButtonRadius) ?? void 0
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.BagDrawerViewBagButton, {
    xs: {
      borderRadius: ((_q = (_p = legacyTheme.componentStyleOverrides) == null ? void 0 : _p.bagDrawerViewBagButton) == null ? void 0 : _q.globalButtonRadius) ?? void 0
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.BagButton, {
    xs: {
      ...outlineStyle,
      color: (bagButtonMobile == null ? void 0 : bagButtonMobile.textFontColor) ?? void 0,
      ...(bagButtonMobile == null ? void 0 : bagButtonMobile.textButton) ? {
        // text button
        fontSize: getNumericValue(bagButtonMobile == null ? void 0 : bagButtonMobile.textFontSize)
      } : {
        // icon button
        height: getNumericValue(bagButtonMobile == null ? void 0 : bagButtonMobile.size),
        width: getNumericValue(bagButtonMobile == null ? void 0 : bagButtonMobile.size),
        fontSize: getNumericValue(bagButtonMobile == null ? void 0 : bagButtonMobile.countNumberSize) ?? void 0
      }
    },
    md: {
      color: (bagButton == null ? void 0 : bagButton.textFontColor) ?? void 0,
      ...(bagButton == null ? void 0 : bagButton.textButton) ? {
        // text button
        fontSize: getNumericValue(bagButton == null ? void 0 : bagButton.textFontSize)
      } : {
        // icon button
        height: getNumericValue(bagButton == null ? void 0 : bagButton.size),
        width: getNumericValue(bagButton == null ? void 0 : bagButton.size),
        fontSize: getNumericValue(bagButton == null ? void 0 : bagButton.countNumberSize) ?? void 0
      }
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.EmptyBagMessageCardButton, {
    xs: {
      color: (emptyBagMessageCardButton == null ? void 0 : emptyBagMessageCardButton.textColor) || void 0,
      backgroundColor: (emptyBagMessageCardButton == null ? void 0 : emptyBagMessageCardButton.backgroundColor) || void 0
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.CheckoutQuantityControl, {
    xs: {
      backgroundColor: (checkoutQuantityControl == null ? void 0 : checkoutQuantityControl.backgroundColor) || void 0,
      color: (checkoutQuantityControl == null ? void 0 : checkoutQuantityControl.textColor) || void 0
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.MembershipButton, {
    xs: {
      color: (membershipButtonMobile == null ? void 0 : membershipButtonMobile.textFontColor) || void 0,
      ...(membershipButtonMobile == null ? void 0 : membershipButtonMobile.textButton) ? {
        // text button
        fontSize: getNumericValue(membershipButtonMobile == null ? void 0 : membershipButtonMobile.textFontSize)
      } : {
        // icon button
        height: getNumericValue(membershipButtonMobile == null ? void 0 : membershipButtonMobile.size),
        width: getNumericValue(membershipButtonMobile == null ? void 0 : membershipButtonMobile.size)
      }
    },
    md: {
      color: (membershipButton == null ? void 0 : membershipButton.textFontColor) || void 0,
      ...(membershipButton == null ? void 0 : membershipButton.textButton) ? {
        // text button
        fontSize: getNumericValue(membershipButton == null ? void 0 : membershipButton.textFontSize)
      } : {
        // icon button
        height: getNumericValue(membershipButton == null ? void 0 : membershipButton.size),
        width: getNumericValue(membershipButton == null ? void 0 : membershipButton.size)
      }
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.ProfileButton, {
    xs: {
      color: (profileButtonMobile == null ? void 0 : profileButtonMobile.textFontColor) || void 0,
      ...(profileButtonMobile == null ? void 0 : profileButtonMobile.textButton) ? {
        // text button
        fontSize: getNumericValue(profileButtonMobile == null ? void 0 : profileButtonMobile.textFontSize)
      } : {
        // icon button
        height: getNumericValue(profileButtonMobile == null ? void 0 : profileButtonMobile.size),
        width: getNumericValue(profileButtonMobile == null ? void 0 : profileButtonMobile.size)
      }
    },
    md: {
      color: (profileButton == null ? void 0 : profileButton.textFontColor) || void 0,
      ...(profileButton == null ? void 0 : profileButton.textButton) ? {
        // text button
        fontSize: getNumericValue(profileButton == null ? void 0 : profileButton.textFontSize)
      } : {
        // icon button
        height: getNumericValue(profileButton == null ? void 0 : profileButton.size),
        width: getNumericValue(profileButton == null ? void 0 : profileButton.size)
      }
    }
  });
  addIfNotEmpty(componentCSSOverrides, ButtonName.LocationMapSearchResultsButton, {
    xs: {
      backgroundColor: (locationMapSearchResultsButton == null ? void 0 : locationMapSearchResultsButton.backgroundColor) || void 0,
      color: (locationMapSearchResultsButton == null ? void 0 : locationMapSearchResultsButton.textColor) || void 0
    }
  });
  return componentCSSOverrides;
};
const isLegacyTheme = (legacyTheme) => {
  if (typeof legacyTheme !== "object" || !legacyTheme) {
    return false;
  }
  return "activeInpageCheckout" in legacyTheme || "componentStyleOverrides" in legacyTheme;
};
const isServerTheme = (theme) => {
  if (typeof theme !== "object" || !theme) {
    return false;
  }
  return "settings" in theme && "content" in theme;
};
const parseLegacyDtcThemeResponse = (legacyTheme, isShopDomain = false) => {
  if (!isLegacyTheme(legacyTheme) && isServerTheme(legacyTheme)) {
    return legacyTheme;
  }
  if (!isLegacyTheme(legacyTheme)) {
    return void 0;
  }
  const dtcMode = legacyTheme.activeInpageCheckout ? "inpage" : "checkout-bar";
  const { fontSettings, typography } = getThemeTypography(legacyTheme);
  const theme = {
    settings: {
      app: getThemeAppSettings(legacyTheme),
      featureFlags: getThemeFeatureFlags(legacyTheme),
      fonts: fontSettings
    },
    dtcMode,
    content: getThemeContentPresets(legacyTheme, isShopDomain),
    globalComponentPresets: {
      pill: getThemePillPresets(legacyTheme),
      checkoutDrawer: getThemeCheckoutDrawerPresets(legacyTheme)
    },
    components: getThemeComponentPresets(legacyTheme),
    componentCSSOverrides: getThemeComponentCSSOverrides(legacyTheme),
    typography,
    ...legacyTheme.customCss ? { customCss: legacyTheme.customCss } : {},
    ...getThemeColors(legacyTheme)
  };
  return theme;
};
const buildThemeFromServerTheme = (styleData, isShopDomain = false) => {
  if (!styleData) {
    return void 0;
  }
  const parsedTheme = parseLegacyDtcThemeResponse(styleData, isShopDomain);
  if (parsedTheme && typeof parsedTheme === "object" && "primary" in parsedTheme) {
    const { primary, secondary, tertiary, accent, background, draftId: _draftId, textColor, ...rest } = parsedTheme;
    const palette = {
      primary,
      secondary,
      tertiary,
      accent,
      background,
      text: {
        primary: textColor,
        secondary: textColor && alpha(textColor, 0.7)
      },
      ...textColor && {
        default: {
          main: textColor
        }
      }
    };
    return filterShallowUndefinedObjectEntries({ ...rest, palette });
  }
  return styleData;
};
export {
  buildThemeFromServerTheme,
  parseLegacyDtcThemeResponse
};
//# sourceMappingURL=parseLegacyDtcThemeResponse.js.map
